<template>
    <div class="home">
      <h1>欢迎使用 AI 内容生成器</h1>
      <p>选择左侧菜单开始创作吧！</p>
    </div>
  </template>
  
  <style scoped>
  .home {
    text-align: center;
    padding: 20px;
  }
  </style>